"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpgradeToTraceTeamDialog = void 0;

var _reactRouter = require("react-router");

require("./UpgradeToTraceTeamDialog.css");

var _ = require("../..");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Import
// Update To Trace Team Dialog
var UpgradeToTraceTeamDialog = function UpgradeToTraceTeamDialog(_ref) {
  var title = _ref.title,
      onClose = _ref.onClose,
      features = _ref.features,
      buttonTitle = _ref.buttonTitle,
      contentTitle = _ref.contentTitle,
      onUpgradeClick = _ref.onUpgradeClick,
      completed = _ref.completed,
      loading = _ref.loading;
  var history = (0, _reactRouter.useHistory)();

  var handleOnClose = function handleOnClose(e) {
    if (typeof onClose === "function") {
      onClose(history);
    }
  };

  var handleOnUpgradeClick = function handleOnUpgradeClick(e) {
    if (typeof onUpgradeClick === "function") {
      onUpgradeClick(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_.Modal, {
    trkContext: "Upgrade To Trace Family Dialog",
    className: "UpgradeToTraceTeamDialog",
    open: true,
    onShadeClick: function onShadeClick(e) {
      return handleOnClose(e);
    }
  }, /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    className: "header"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    center: true,
    type: _.Label.Type.Heading4,
    content: title,
    color: _.Color.Black,
    span: 12
  }), /*#__PURE__*/_react.default.createElement(_.RoundButton, {
    trkAction: "Close Pressed",
    className: "button-close",
    borderColor: _.Color.White2,
    icon: _.Icon.Type.Close,
    color: _.Color.Grey3,
    onClick: function onClick(e) {
      return handleOnClose(e);
    },
    iconSize: 30
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    className: "subtitle",
    type: _.Label.Type.Heading2,
    color: _.Color.Black,
    marginBottom: "6"
  }, contentTitle), /*#__PURE__*/_react.default.createElement(_.Column, {
    paddingLeft: "6",
    paddingRight: "6"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-features"
  }, features.map(function (feature, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "upgrade-dialog-li-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      className: "feature",
      type: _.Label.Type.Body,
      color: _.Color.Grey1
    }, feature));
  })))), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Column, {
    alignItems: "center",
    justifyContent: "center"
  }, loading && /*#__PURE__*/_react.default.createElement(_.Loading, null), !completed && !loading && /*#__PURE__*/_react.default.createElement(_.Button, {
    primary: true,
    trkAction: "Upgrade to Trace Family Pressed",
    onClick: function onClick(e) {
      return handleOnUpgradeClick(e);
    },
    content: /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_.Icon, {
      size: 16,
      type: _.Icon.Type.Upgrade
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      type: _.Label.Type.InnerButton,
      content: buttonTitle,
      marginLeft: "2"
    }))
  }), completed && !loading && /*#__PURE__*/_react.default.createElement(_.Row, null, /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: _.Icon.Type.Check,
    color: _.Color.TraceTint1,
    marginRight: "2"
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    color: _.Color.Trace,
    type: _.Label.Type.Body,
    bold: true,
    content: "We'll be in touch to setup your team."
  })))));
};

exports.UpgradeToTraceTeamDialog = UpgradeToTraceTeamDialog;
UpgradeToTraceTeamDialog.defaultProps = {
  title: "Trace Team",
  contentTitle: "Upgrade to Team and save $2000 🤑",
  buttonTitle: "Contact us",
  features: ["Only $180-200/player per year", "Tactical playlists like goals, progressions and more", "Personalized moments and stats for every player", "FREE implementation and recruiting workshops"]
};